import { PrivateRoute, callbackRoute } from '@airship-platform/airship-auth';
import { withPageProps } from '@airship-platform/airship-patterns';
import {
  Loader,
  NotFoundPage as BaseNotFoundPage,
} from '@airship-platform/jam-web/components';
import { RouteObject } from 'react-router';
import OnboardingPage from '../features/onboarding/components/OnboardingPage';
import SignUpPage from '../features/signup/components/SignUpPage';
import RegistrationBaseTemplate from '../patterns/components/RegistrationBaseTemplate';
import TermsOfService from '../patterns/components/TermsOfService';
import ROUTE_PATHS from './paths';

const OnboardingPageImpl = withPageProps(OnboardingPage, {
  title: 'Onboarding',
});
const SignUpPageImpl = withPageProps(SignUpPage, {
  title: 'Sign Up',
});
const TermsOfServiceImpl = withPageProps(TermsOfService, {
  title: 'Terms of Service',
});

const routes: RouteObject[] = [
  callbackRoute(),
  {
    path: '*',
    Component: withPageProps(BaseNotFoundPage, { title: 'Page not found' }),
  },
  {
    path: ROUTE_PATHS.ONBOARDING,
    element: (
      <PrivateRoute
        allowedRoles={['OWNER']}
        loadingComponent={<Loader isLoading />}
      >
        <RegistrationBaseTemplate hasHeader helpEnabled />
      </PrivateRoute>
    ),
    children: [
      {
        path: '',
        element: <OnboardingPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.HOME,
    element: <RegistrationBaseTemplate hasHeader />,
    children: [
      {
        path: '',
        element: <SignUpPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.TERMS_OF_SERVICE,
    element: <TermsOfServiceImpl />,
  },
];

export default routes;
